export default "__VITE_ASSET__BU3eK9Wu__"